import { Collapse } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

export const StyledCollapse = muiStyled(Collapse)(() => ({
  width: '100%',
  '& .MuiCheckbox-root': {
    paddingLeft: 0,
  },
}));
